import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as _ from 'lodash'
// ✅ IMPORT DIRECTO (NO usar '../../../auth')
import { AuthService } from '../../../auth/_services/auth.service'; // <-- ajusta a tu ruta real


@Injectable()
export class InterceptService implements HttpInterceptor {
  // Evita múltiples redirects en ráfaga
  private redirecting = false;

  constructor(
	private router: Router,
	public authService: AuthService
) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        const httpError = error as HttpErrorResponse;

        // Si quieres excluir algunas URLs específicas (como ya haces)
        if (request.url.includes('company/all')) {
          // RxJS 6 recibe el error directamente. La firma con factory
          // pertenece a versiones posteriores y ocultaba el HttpErrorResponse.
          return throwError(error);
        }

        const status = _.get(httpError, 'status', 0);

        // 0 suele ser cancelado/CORS/offline: NO mandar a login
        // 500/503/etc: NO mandar a login
        const shouldGoLogin = status === 401 || status === 419;

        if (shouldGoLogin) {
			this.authService.signOut();
          const alreadyOnLogin = this.router.url.startsWith('/auth/login') || this.router.url.startsWith('/auth');

          if (!alreadyOnLogin && !this.redirecting) {
            this.redirecting = true;

            // Si quieres, limpia tokens aquí (si aplica)
            // localStorage.removeItem('accessToken');

            this.router.navigate(['/auth/login']).finally(() => {
              // libera el lock después de un tick para evitar spam
              setTimeout(() => (this.redirecting = false), 0);
            });
          }
        }

        // IMPORTANTE: propaga el error para que el caller lo maneje si quiere
        return throwError(error);
      })
    );
  }
}
